// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.renter.v1.CappsScreeningReportsWebApiHandler

import type { UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsScreeningReportsWebApiHandler_createReports,
  CappsScreeningReportsWebApiHandler_retrieveReports,
  CappsScreeningReportsWebApiHandler_retrieveReports_Path,
} from '@zg-rentals/ts-capps-client';

import type { CreateReportsRequestDto, ListingAlias, ScreeningReportData } from '@zg-rentals/ts-capps-client';

interface RetrieveReportsParams {
  listingAlias?: ListingAlias;
  requestingClient: string;
  zipCode?: string;
}

export interface CappsScreeningReportsWebApiHandler_createReports_Args {
  postData: CreateReportsRequestDto;
}

export type CappsScreeningReportsWebApiHandler_createReports_Options = UseMutationOptions<
  void,
  unknown,
  CappsScreeningReportsWebApiHandler_createReports_Args
>;

export const useCappsScreeningReportsWebApiHandler_createReports = ({
  httpClient,
  ...options
}: Omit<CappsScreeningReportsWebApiHandler_createReports_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsScreeningReportsWebApiHandler_createReports_Args) =>
      CappsScreeningReportsWebApiHandler_createReports(args.postData, httpClient),
  });
};

export type CappsScreeningReportsWebApiHandler_retrieveReports_Options = UseQueryOptions<
  ScreeningReportData,
  unknown,
  ScreeningReportData,
  Array<string | RetrieveReportsParams>
>;

const CappsScreeningReportsWebApiHandler_retrieveReports_GetKey = (getParams: RetrieveReportsParams) => [
  CappsScreeningReportsWebApiHandler_retrieveReports_Path,
  getParams,
];

export const useCappsScreeningReportsWebApiHandler_retrieveReports = (
  getParams: RetrieveReportsParams,
  {
    httpClient,
    ...options
  }: Omit<CappsScreeningReportsWebApiHandler_retrieveReports_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: CappsScreeningReportsWebApiHandler_retrieveReports_GetKey(getParams),
    queryFn: () => CappsScreeningReportsWebApiHandler_retrieveReports(getParams, httpClient),
  });
};
useCappsScreeningReportsWebApiHandler_retrieveReports.getKey =
  CappsScreeningReportsWebApiHandler_retrieveReports_GetKey;
